import { RemoteDeveloperPackage } from "../../../../data/usecases/developer-package/remote-developer-package";
import { DeveloperPackage } from "../../../../domain/models/developer-package.model";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteDeveloperPackage = (): DeveloperPackage =>
  new RemoteDeveloperPackage(
    "/developers-package",
    makeAxiosHttpClient(),
    settings.API_URL
  );
